import { render } from "./CoBrandThemeClassic.vue?vue&type=template&id=e8c9a5d0&scoped=true"
import script from "./CoBrandThemeClassic.vue?vue&type=script&lang=js"
export * from "./CoBrandThemeClassic.vue?vue&type=script&lang=js"

import "./CoBrandThemeClassic.vue?vue&type=style&index=0&id=e8c9a5d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c9a5d0"]])

export default __exports__